/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AmenityView } from '../models/amenity-view';
import { ListingTypeView } from '../models/listing-type-view';
import { MigrateResponse } from '../models/migrate-response';
import { TestDataGenerateListingsResult } from '../models/test-data-generate-listings-result';
import { UtilityStatusView } from '../models/utility-status-view';

@Injectable({
  providedIn: 'root',
})
export class DataService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getAmenities
   */
  static readonly GetAmenitiesPath = '/api/Data/GetAmenities';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAmenities()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAmenities$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<AmenityView>>> {

    const rb = new RequestBuilder(this.rootUrl, DataService.GetAmenitiesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AmenityView>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAmenities$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAmenities(params?: {
    context?: HttpContext
  }
): Observable<Array<AmenityView>> {

    return this.getAmenities$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AmenityView>>) => r.body as Array<AmenityView>)
    );
  }

  /**
   * Path part for operation getUtilityStatus
   */
  static readonly GetUtilityStatusPath = '/api/Data/GetUtilityStatus';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUtilityStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUtilityStatus$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<UtilityStatusView>>> {

    const rb = new RequestBuilder(this.rootUrl, DataService.GetUtilityStatusPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<UtilityStatusView>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getUtilityStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUtilityStatus(params?: {
    context?: HttpContext
  }
): Observable<Array<UtilityStatusView>> {

    return this.getUtilityStatus$Response(params).pipe(
      map((r: StrictHttpResponse<Array<UtilityStatusView>>) => r.body as Array<UtilityStatusView>)
    );
  }

  /**
   * Path part for operation getListingTypes
   */
  static readonly GetListingTypesPath = '/api/Data/GetListingTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getListingTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getListingTypes$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<ListingTypeView>>> {

    const rb = new RequestBuilder(this.rootUrl, DataService.GetListingTypesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ListingTypeView>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getListingTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getListingTypes(params?: {
    context?: HttpContext
  }
): Observable<Array<ListingTypeView>> {

    return this.getListingTypes$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ListingTypeView>>) => r.body as Array<ListingTypeView>)
    );
  }

  /**
   * Path part for operation version
   */
  static readonly VersionPath = '/api/Data/Version';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `version()` instead.
   *
   * This method doesn't expect any request body.
   */
  version$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, DataService.VersionPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `version$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  version(params?: {
    context?: HttpContext
  }
): Observable<string> {

    return this.version$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation migrate
   */
  static readonly MigratePath = '/api/Data/Migrate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `migrate()` instead.
   *
   * This method doesn't expect any request body.
   */
  migrate$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<MigrateResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DataService.MigratePath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MigrateResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `migrate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  migrate(params?: {
    context?: HttpContext
  }
): Observable<MigrateResponse> {

    return this.migrate$Response(params).pipe(
      map((r: StrictHttpResponse<MigrateResponse>) => r.body as MigrateResponse)
    );
  }

  /**
   * Path part for operation getListingRelationships
   */
  static readonly GetListingRelationshipsPath = '/api/Data/GetListingRelationships';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getListingRelationships()` instead.
   *
   * This method doesn't expect any request body.
   */
  getListingRelationships$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<string>>> {

    const rb = new RequestBuilder(this.rootUrl, DataService.GetListingRelationshipsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getListingRelationships$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getListingRelationships(params?: {
    context?: HttpContext
  }
): Observable<Array<string>> {

    return this.getListingRelationships$Response(params).pipe(
      map((r: StrictHttpResponse<Array<string>>) => r.body as Array<string>)
    );
  }

  /**
   * Path part for operation getUserRelationships
   */
  static readonly GetUserRelationshipsPath = '/api/Data/GetUserRelationships';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserRelationships()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserRelationships$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<string>>> {

    const rb = new RequestBuilder(this.rootUrl, DataService.GetUserRelationshipsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getUserRelationships$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserRelationships(params?: {
    context?: HttpContext
  }
): Observable<Array<string>> {

    return this.getUserRelationships$Response(params).pipe(
      map((r: StrictHttpResponse<Array<string>>) => r.body as Array<string>)
    );
  }

  /**
   * Path part for operation generateListings
   */
  static readonly GenerateListingsPath = '/api/Data/GenerateListings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `generateListings()` instead.
   *
   * This method doesn't expect any request body.
   */
  generateListings$Response(params?: {
    numberOfListings?: number;
    addToDatabase?: boolean;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<TestDataGenerateListingsResult>> {

    const rb = new RequestBuilder(this.rootUrl, DataService.GenerateListingsPath, 'get');
    if (params) {
      rb.query('numberOfListings', params.numberOfListings, {});
      rb.query('addToDatabase', params.addToDatabase, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TestDataGenerateListingsResult>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `generateListings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  generateListings(params?: {
    numberOfListings?: number;
    addToDatabase?: boolean;
    context?: HttpContext
  }
): Observable<TestDataGenerateListingsResult> {

    return this.generateListings$Response(params).pipe(
      map((r: StrictHttpResponse<TestDataGenerateListingsResult>) => r.body as TestDataGenerateListingsResult)
    );
  }

  /**
   * Path part for operation signup
   */
  static readonly SignupPath = '/api/Data/Signup';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `signup()` instead.
   *
   * This method doesn't expect any request body.
   */
  signup$Response(params?: {
    email?: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DataService.SignupPath, 'post');
    if (params) {
      rb.query('email', params.email, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `signup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  signup(params?: {
    email?: string;
    context?: HttpContext
  }
): Observable<void> {

    return this.signup$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
